import { createGlobalStyle } from 'styled-components'

const HelperClass = createGlobalStyle`
    body {
        width: 100%;
        min-height: 100vh;
        margin: 0;
        padding: 0;
        color: var(--cream);
        font-family: maisonMedium;
        -webkit-overflow-scrolling: touch;
        overflow-x: hidden;
        overflow-y: ${(props) => (props.isBurgerMenuOpen || props.isPreloaderPlay || props.isPopupOpen ? 'hidden' : '')};

        ${(props) =>
        props.isBurgerMenuOpen || props.isPreloaderPlay || props.isPopupOpen
            ? ` 
                    touch-action: none;
                    -ms-touch-action: none;
                `
            : ``}

        position: relative;
        background: var(--black);

        .animStartStateSlide {
            opacity: 0;
            transform: translateY(100px);
        }

        .translate-200 {
            transform: translateY(200%);
        }

        .translate-100 {
            transform: translateY(100%);
        }

        .animStartStateWidth {
            width: 0%;
        }

        .min-width{
            min-width: 100vw;
            
        }

        .min-height{
            min-height: 100vh;   
        }

        main {
            z-index: 1;
            position: relative;
        }
        
        #__next {
            min-height: 100vh;
        }

        #root {
            overflow-x: hidden;
        }

        ::-webkit-scrollbar {
            display: none;
        }

        &.hidden {
            overflow:hidden;
            max-height:100vh;
        }
    }

    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .loading {
        animation: opacityAnimate 1s infinite;
        pointer-events: none;
    }

    .modal-open {
        overflow-y: hidden;
    }

    .special-price {
        position: absolute;
        top: var(--productOverIconPosition);
        left: var(--productOverIconPosition);
        color: var(--white);
        background: var(--orange);
        padding: var(--sp1x) var(--sp2x);
        border-radius: var(--sp4x);
        z-index: 2;
    }

    .gender-icon {
        position: absolute;
        top: var(--productOverIconPosition);
        right: var(--productOverIconPosition);
        font-size: var(--h6);
        color: var(--black);
    }

    input[type="text" i] {
        padding: 0px 0px;
    }

    input[type="search" i] {
        padding: 0px 0px;
    }

    ul,
    fieldset {
        margin: 0;
        padding: 0;
        list-style: none;
        border: none;
    }

    .heightFitContent {
        height: fit-content;
    }

    .inline-block {
        display: inline-block;
    }

    //! Flex

    .FlexBoxContainer {
        display: flex;
        flex-wrap: wrap;
    }

    .FlexBoxColumn {
        display: flex;
        flex-direction: column;
    }

    .FlexBox {
        display: flex;
    }

    .alignMiddle {
        align-items: center;
    }

    .alignCenter {
        justify-content: center;
    }

    .justifyEnd {
        justify-content: flex-end;
    }

    .alignEnd{
        align-items: flex-end;
    }

    .rowReverse {
        flex-direction: row-reverse;
    }

    .spaceBetween {
        justify-content: space-between;
    }

    .spaceAround {
        justify-content: space-around;
    }

    .flexWrap {
        flex-wrap: wrap;
    }

    //! Cursor

    .cursorPointer{
        cursor:pointer;
    }
    .cursorDefault{
        cursor: default;
    }

    //! Text

    .textAlignCenter {
        text-align: center;
    }

    .textAlignRight {
        text-align: right;
    }

    //! relative

    .relativeWrap{
        position: relative;
    }

    //! overflow
    .overflowHidden{
        overflow: hidden;
    }

    @keyframes opacityAnimate {
        0%, 100% {
            opacity: 0.6;
        }
        50% {
            opacity: 0.4;
        }
    }
`

export default HelperClass
